import { Injectable } from '@angular/core';

import { filter, find, xor } from 'lodash';

import { Field } from './models';

@Injectable({
    providedIn: 'root'
})
export class ReportDefinitionGridsLogicService {

    constructor() { }

    formContainsMultipleGrids(fields: Field[]): boolean {
        const gridDataIds = new Set<string>();

        fields.forEach((field: Field) => {
            if (field.dataId) {
                gridDataIds.add(field.dataId);
            }
        });

        return gridDataIds.size > 1;
    }

    xored(selectedFields: Field[], allFields: Field[]): Field[] {
        if (selectedFields.length === 0) {
            return allFields;
        }

        const xored: Field[] = xor(allFields, selectedFields);

        const gridField: Field | undefined = find(selectedFields, function (o: Field): boolean {
            return Boolean(o.dataId);
        });

        if (gridField !== undefined) {
            const hasSameDataIdOrIsDefaultField: Field[] = filter(xored, function (field: Field) {
                return (field.dataId === gridField.dataId || field.dataId === undefined) && (field.id !== gridField.id);
            });
            return hasSameDataIdOrIsDefaultField;
        }

        return xored;
    }
}
